var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#666",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44 20.8v-14.2c0-1.19999998-1-2.19999998-2.2-2.19999998h-14.8c-1.2 0-2.2 1-2.2 2.19999998v14.2c0 1.2 1 2.2 2.2 2.2h14.8c1.2 0 2.2-1 2.2-2.2zm-37.79999998 4.4c-1.20000004 0-2.20000004 1-2.20000004 2.2v14.2c0 1.2 1 2.2 2.20000004 2.2h14.79999998c1.2 0 2.2-1 2.2-2.2v-14.2c0-1.2-1-2.2-2.2-2.2zm8.19999998-9.6h-2.2c0-3.8 3.2-6.99999998 7-6.99999998h.8c.6 0 1-.39999999 1-1.00000004v-2.6c0-.59999996-.4-1-1-1h-.8c-6.4 0-11.60000002 5.20000004-11.60000002 11.60000002h-2.59999996c-.39999999 0-.6.4-.6.8 0 .2 0 .2.19999996.4l4.40000002 5c.40000002.4.99999998.4 1.4 0l4.4-5c.2-.2.2-.6 0-.8s-.2-.4-.4-.4zm19.2 16.8h2.2c0 3.8-3.2 7-7 7h-.8c-.6 0-1 .4-1 1v2.8c0 .6.4 1 1 1h.8c6.4 0 11.6-5.2 11.6-11.6h2.6c.4 0 .6-.2.6-.6 0-.2 0-.2-.2-.4l-4.4-5c-.4-.4-1-.4-1.4 0l-4.4 5c-.2.2-.2.6 0 .8 0-.2.2 0 .4 0z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.ee02cf7113f7dbfe7eae563579ef684c.svg";
export { ForwardRef as ReactComponent };